export const getContentTypeOutOfResponse = (response) => {
	const contentType = response.headers.get("content-type");

	if (!contentType) {
		return undefined;
	}

	const contentTypeParts = contentType.split(";");

	return contentTypeParts[0];
};

const extractFilename = (url) => {
	const matches = url.match(/\/([^\/?#]+)(?=[?#]|$)/g);
	if (matches && matches.length > 0) {
		const lastMatch = matches[matches.length - 1];
		return lastMatch.substring(1);
	}
	return null;
};

const generateIndexedFilename = (filename, index) => {
	const splitFileName = filename.split(".");

	const noExtension = splitFileName.length === 1;
	if (noExtension) {
		return `${filename}_${index}`;
	}

	const extension = splitFileName.pop();
	const name = splitFileName.join(".");
	return `${name}_${index}.${extension}`;
};

export const urlArrayToShareFiles = async (urlArray) => {
	if (!urlArray || urlArray.length === 0) {
		return undefined;
	}

	let files = [];
	let fileNames = [];

	for (let i = 0; i < urlArray.length; i++) {
		const url = urlArray[i];

		try {
			const fetchResult = await fetch(url);

			if (!fetchResult.ok) {
				throw new Error(`Failed to fetch image ${fetchResult}`);
			}

			const contentType = getContentTypeOutOfResponse(fetchResult);

			const blob = await fetchResult.blob();

			// snaha vzít filename z content disposition, pokud nejde, tak z url
			// jinak defaultní hodnota
			let filename = extractFilename(url) ?? `image_${i}`;

			if (fileNames.includes(filename)) {
				filename = generateIndexedFilename(filename, i);
			}

			fileNames.push(filename);

			files.push(new File([blob], filename, { type: contentType }));
		} catch (err) {
			console.error(
				"[INTERACTIVE-PRODUCTS] Error while fetching image for sharing",
				err
			);
			return null;
		}
	}

	if (files.length === 0) {
		return undefined;
	}

	return files;
};
